<template>
<v-app>
  <div>
    <v-progress-circular v-show="saveLoading"
                         indeterminate
                         color="primary"
    ></v-progress-circular>

        <v-layout style="margin-left: 0;">
            <v-layout row wrap>
                <div class="dropbox">
                    <input type="file" ref="file" multiple :name="uploadFieldName"
                           @change="filesChange($event.target.name, $event.target.files);"
                           accept=".pdf" class="input-file">
                    <p>
                        將檔案(一張或多張)拖到此處<br> 或點擊上傳
                    </p>
                </div>
            </v-layout>

            <v-layout row wrap v-if="uploadedFiles.length > 0"
                    class="margin-bottom"
                    v-for="(file, index) in uploadedFiles"
                    :key="`${file.name}_${index}`">
                <div class="imgBox" :key="`${file.name}_${index}`">
                    <v-flex type="flex" :gutter="2">
                        <v-layout md8 style="padding-left: 0.5rem; ">
                            <span class="image-title">{{file.name}}</span>
                        </v-layout>
                        <v-layout md4>
                          <v-btn color="error" dark text style="margin: 5px;"
                                     @click="removeUploadImage(file.name)">刪除</v-btn>
                        </v-layout>
                    </v-flex>
                </div>
            </v-layout>

            <v-layout row wrap v-if="getUserFileList.length > 0"
                    class="margin-bottom"
                    v-for="(imgItem, index) in getUserFileList"
                    :key="`${imgItem.imageName}_${index}`"
                    :xs="8"
                    :sm="6"
                    :md="6">
                <div v-if="imgItem.data">
                    <v-layout row wrap>
                        <v-flex md8 style="padding-left: 0.5rem;">
                            <a :href="getImageData(imgItem)"
                               :alt="imgItem.imageName"
                               class="image-title">{{imgItem.imageName}}</a>
                        </v-flex>
                        <v-flex md6>
                          <v-btn color="error" dark text
                                     style="margin: 5px;"
                                     @click="removeImage(imgItem.imageName)">刪除</v-btn>
                        </v-flex>
                    </v-layout>
                </div>
                <div v-else :key="getUrl(imgItem.imageName, index)">
                    <v-layout row wrap>
                        <v-flex md8 style="padding-left: 0.5rem;">
                            <a :href="imgUrl" :ref="`${itemDetail.userId}${index}`"
                               :alt="imgItem.imageName"
                               class="image-title">{{imgItem.imageName}}</a>
                        </v-flex>
                        <v-flex md4>
                          <v-btn color="error" dark text style="margin: 5px;"
                                @click="removeImage(imgItem.imageName)">刪除</v-btn>
                        </v-flex>
                    </v-layout>
                </div>
            </v-layout>
        </v-layout>
        <v-layout row wrap v-if="uploadedFiles.length > 0 || (getUserFileList.length > 0)">
          <v-flex lg3 md3 xs12 sm12 offset-xs2 offset-md2 >
            <v-btn class="primary" dark text @click="save">上傳</v-btn>
          </v-flex>
        </v-layout>
    </div>
</v-app>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import App from '../App.vue';

export default {
  components: { App },
  props: ['itemDetail', 'uploadType'],
  name: 'UploadView',
  data() {
    return {
      uploadedFiles: [],
      uploadFieldName: 'photos',
      imageInfo: {
        imageName: '',
        sort: 0,
      },
      saveLoading: false,
      loadingText: '上傳中...',
      imgUrl: 'http://fakeimg.pl/350x200/?text=Loading&font=lobster',
      visionResults: [],
      count: 0,
    };
  },
  computed: {
    ...mapGetters(['getUserInfo']),
    getUserFileList() {
      // console.log(`image list == ${this.uploadType} , ${JSON.stringify(this.itemDetail)}`);
      if (this.itemDetail.fileList) {
        const list = this.itemDetail.fileList.slice();
        return list;
        // return list.filter(image => image.type === this.uploadType || image.type === 'add' );
      }
      return [];
    },
  },
  methods: {
    ...mapActions(['updateData', 'getImageUrl', 'removeData', 'uploadImageData', 'saveFinanceCreditData']),
    insertImage() {
      if (this.imageInfo.imageName.length < 1) {
        this.$message({
          message: '不可為空',
          type: 'warning',
        });
        return;
      }
      if (!this.itemDetail.fileList) {
        this.itemDetail.fileList = [];
      }
      const isDuplicate = this.itemDetail.fileList
        .slice().some(item => item.imageName === this.imageInfo.imageName);
      if (isDuplicate) {
        this.$message({
          message: '檔案重複',
          type: 'warning',
        });
      } else {
        Object.assign(this.imageInfo, {
          sort: this.itemDetail.fileList.length,
        });
        this.itemDetail.fileList
          .splice(this.itemDetail.fileList.length, 1, JSON.parse(JSON.stringify(this.imageInfo)));
        Object.assign(this.imageInfo, {
          imageName: '',
        });
      }
    },
    removeImage(imgName) {
      this.itemDetail.fileList.forEach((item, index) => {
        if (item.imageName === imgName) {
          this.itemDetail.fileList.splice(index, 1);
        }
      });
      this.saveFinanceCreditData(this.itemDetail);
    },
    removeUploadImage(imgName) {
      this.uploadedFiles.forEach((item, index) => {
        if (item.name === imgName) {
          this.uploadedFiles.splice(index, 1);
        }
      });
    },
    getImageData(item) {
      console.log(`getImageData === ${JSON.stringify(item)}`);
      if (item) {
        return item.data;
      }
      return 'http://fakeimg.pl/350x200/?text=Error&font=lobster';
    },
    getUrl(imgName, index) {
      const path = `${this.itemDetail.caseId}/${imgName}`;

      this.getImageUrl(`userImages/${path}`).then((url) => {
        this.$refs[`${this.itemDetail.caseId}${index}`][0].src = url;
      }).catch(() => {
        this.$refs[`${this.itemDetail.caseId}${index}`][0].src = 'http://fakeimg.pl/350x200/?text=Error&font=lobster';
      });
      return index;
    },
    save() {
      this.loadingText = '上傳中...';
      console.log(`this.uploadedFiles.length === ${this.uploadedFiles.length}`);
      if (this.uploadedFiles && this.uploadedFiles.length > 0) { // 是否有圖片要上傳
        this.saveLoading = true;
        let uploadCount = 0;

        this.uploadedFiles.forEach((item) => {
          console.log(`user === ${this.itemDetail.caseId} image = ${item.fileItem}`);
          const path = `${this.itemDetail.caseId}/${item.name}`;
          this.$store.dispatch('uploadImageData', {
            name: `caseFiles/${path}`,
            image: item.fileItem,
          }).then((response) => {
            console.log(`uploadImageData success ${JSON.stringify(response)}`);
            uploadCount += 1;

            // 加入新圖資料
            if (!this.itemDetail.fileList) {
              this.itemDetail.fileList = [];
              const newImage = { imageName: item.name,
                type: this.uploadType,
                sort: 0,
                data: response };
              this.itemDetail.fileList.push(newImage);
            } else {
              const newImage = { imageName: item.name,
                type: this.uploadType,
                sort: this.itemDetail.fileList.length,
                data: response };
              this.itemDetail.fileList.push(newImage);
            }
            // 處理完成更新資料
            if (this.uploadedFiles.length === uploadCount) {
              this.saveUser();
            }
          }, (error) => {
            console.log(`uploadImageData error ${JSON.stringify(error)}`);
            uploadCount += 1;
            if (this.uploadedFiles.length === uploadCount) {
              this.saveLoading = false;
            }
          });
        });
      } else {
        this.saveUser();
      }
    },
    saveUser() {
      // 圖片排序
      if (this.itemDetail.fileList && this.itemDetail.fileList.length > 0) {
        this.itemDetail.fileList.slice().sort((p1, p2) => p1.sort - p2.sort);
      }

      this.saveFinanceCreditData(this.itemDetail);
      this.saveLoading = false;
      this.uploadedFiles = [];
      this.$emit('onFinishFileUpload', this.itemDetail);
    },
    filesChange(fieldName, fileList) {
      const files = Object.values(this.$refs.file.files);
      console.log('== files ==');
      console.log(files);

      // handle file changes
      const formData = new FormData();

      this.visionResults = [];

      if (!fileList.length) return;

      // append the files to FormData
      Array
        .from(Array(fileList.length).keys())
        // eslint-disable-next-line
        .map((x) => {
          formData.append(fieldName, fileList[x], fileList[x].name);

          const file = { name: fileList[x].name, fileItem: fileList[x] };

          this.createImage(file);
        });
    },
    createImage(file) {
      const reader = new FileReader();
      const fileName = file.name;

      reader.onload = (e) => {
        const image = e.target.result;

        const fileItem = { name: fileName, fileItem: image };
        this.uploadedFiles.push(fileItem);
      };
      reader.readAsDataURL(file.fileItem);
    },
  },
};

</script>

<style scoped>
    .imgBox {
        box-shadow: 4px 4px 12px -2px rgba(20%,20%,40%,0.5);

    }

    .image-view {
        width: 100%;
        height: 180px;
        object-fit: scale-down;
    }

    .image-title {

        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
        display: block;
        overflow: hidden
    }


    .dropbox {
        outline: 2px dashed grey; /* the dash box */
        outline-offset: -10px;
        background: white;
        color: dimgray;
        padding: 10px 10px;
        min-height: 200px; /* minimum height */
        position: relative;
        cursor: pointer;
    }

    .input-file {
        opacity: 0; /* invisible but it's there! */
        width: 100%;
        height: 200px;
        position: absolute;
        cursor: pointer;
    }

    .dropbox:hover {
        background: white;
    }

    .dropbox p {
        font-size: 1.2em;
        text-align: center;
        padding: 50px 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/uploadFileTool.vue